import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DebtorDocumentTypeV2 } from 'src/app/_models';
import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { DebtorDocumentNumberType } from '../../../../sharedcomp/constans/debtorDocumentType.constans';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { UserService } from '../../../../_services/user.service';
import { Subject, of } from 'rxjs';
import { CustomValidators, DataService } from '../../../../_helpers';

@Component({
  selector: 'app-new-users-creation',
  templateUrl: './new-users-creation.component.html',
  styleUrls: [
    './new-users-creation.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../../assets/css/new-form-elements.css'
  ]
})
export class NewUsersCreationComponent implements OnInit {

  newUserForm: FormGroup;
  @Output() cancelCreation: EventEmitter<boolean> = new EventEmitter();
  @Output() getCustomerUserList: EventEmitter<boolean> = new EventEmitter();

  @Input() icons: typeof icons;
  @Input() customerId: string;
  @Input() userRoles: string[];

  ddldebtorPhonePrefix: DebtorDocumentTypeV2[] = DebtorDocumentNumberType;
  private destroy$ = new Subject<void>();

  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private userService: UserService
  ) { }

  ngOnInit() {
    let country = localStorage.getItem("country")
    this.ddldebtorPhonePrefix = this.getCountryData(country);
    this.initNewUserForm();
  }

  numberOnly(event: KeyboardEvent): boolean {
    const key = event.key;
    // Permitir números del 0 al 9
    if (/\d/.test(key)) {
      return true;
    }
    return false;
  }

  initNewUserForm() {
    this.newUserForm = this.formBuilder.group({
      name: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required]),
      phone_prefix: new FormControl('', [Validators.required]),
      phone: new FormControl("", [Validators.required]),
      role: new FormControl("Seleccione", [Validators.required, CustomValidators.validateNoPreSelect]),
      status: new FormControl("ACTIVE", [Validators.required]),
      customer: this.formBuilder.group({
        public_id: new FormControl(this.customerId)
      })
    });
  }

  setCustomerStatus() {
    const statusControl = this.newUserForm.get('status').value;
    const currentValue = statusControl === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    this.newUserForm.get('status').patchValue(currentValue);
  }

  changePhonePrefix(event: DebtorDocumentTypeV2['id']) { }
  changeRole(event: string) { }

  closeCreateUserSidebar() {
    this.cancelCreation.emit(false);
  }

  createUser(userForm: FormGroup) {
    this.dataService.loadSpinner(true);
    const { phone_prefix, phone, ...otherUserFormValues } = userForm.getRawValue();
    const newUserForm = { ...otherUserFormValues, phone: phone_prefix + phone };

    this.userService.createUser(newUserForm)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          this.getCustomerUserList.emit(true);
          this.dataService.loadSpinner(false);
          this.closeCreateUserSidebar();
        }),
        catchError(error => {
          console.error('Failed while trying to save the User Details.' + error);
          this.dataService.loadSpinner(false);
          return of([]);
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCountryData(countryCode: string) {
    return this.ddldebtorPhonePrefix.filter((data => data.country === countryCode));
  }
}
